export type IEscolaridade =
    'ANALFABETO' |
    'CURSO SEQUENCIAL COMPLEMENTACAO ESTUDOS' |
    'CURSO SEQUENCIAL FORMACAO ESPECIFICA' |
    'DOUTORADO' |
    'DOUTORADO COMPLETO' |
    'FUNDAMENTAL' |
    'FUNDAMENTAL COMPLETO' |
    'FUNDAMENTAL INCOMPLETO' |
    'MEDIO' |
    'MEDIO COMPLETO' |
    'MEDIO INCOMPLETO' |
    'MESTRADO' |
    'MESTRADO COMPLETO' |
    'POS DOUTORADO' |
    'POS DOUTORADO COMPLETO' |
    'POS GRADUACAO COMPLETO' |
    'POS GRADUACAO LATO SENSU ESPECIALIZACAO' |
    'POS GRADUACAO LATO SENSU RESIDENCIA MEDICA' |
    'PRIMARIO COMPLETO' |
    'PRIMARIO INCOMPLETO' |
    'QUARTA SERIE ENSINO FUNDAMENTAL' |
    'SUPERIOR BACHARELADO' |
    'SUPERIOR COMPLETO' |
    'SUPERIOR INCOMPLETO' |
    'SUPERIOR LICENCIATURA CURTA' |
    'SUPERIOR LICENCIATURA PLENA' |
    'SUPERIOR TECNOLOGO' |
    'TECNICO COMPLETO' |
    'TECNICO ESPECIALIZACAO' |
    'TECNICO HABILITACAO' |
    'TECNICO INCOMPLETO' |
    'TECNICO QUALIFICACAO' |
    'TECNOLOGO COMPLETO' |
    'TECNOLOGO INCOMPLETO'

export const EscolaridadeKeys: IEscolaridade[] = [
    'ANALFABETO',
    'CURSO SEQUENCIAL COMPLEMENTACAO ESTUDOS',
    'CURSO SEQUENCIAL FORMACAO ESPECIFICA',
    'DOUTORADO',
    'DOUTORADO COMPLETO',
    'FUNDAMENTAL',
    'FUNDAMENTAL COMPLETO',
    'FUNDAMENTAL INCOMPLETO',
    'MEDIO',
    'MEDIO COMPLETO',
    'MEDIO INCOMPLETO',
    'MESTRADO',
    'MESTRADO COMPLETO',
    'POS DOUTORADO',
    'POS DOUTORADO COMPLETO',
    'POS GRADUACAO COMPLETO',
    'POS GRADUACAO LATO SENSU ESPECIALIZACAO',
    'POS GRADUACAO LATO SENSU RESIDENCIA MEDICA',
    'PRIMARIO COMPLETO',
    'PRIMARIO INCOMPLETO',
    'QUARTA SERIE ENSINO FUNDAMENTAL',
    'SUPERIOR BACHARELADO',
    'SUPERIOR COMPLETO',
    'SUPERIOR INCOMPLETO',
    'SUPERIOR LICENCIATURA CURTA',
    'SUPERIOR LICENCIATURA PLENA',
    'SUPERIOR TECNOLOGO',
    'TECNICO COMPLETO',
    'TECNICO ESPECIALIZACAO',
    'TECNICO HABILITACAO',
    'TECNICO INCOMPLETO',
    'TECNICO QUALIFICACAO',
    'TECNOLOGO COMPLETO',
    'TECNOLOGO INCOMPLETO'
]

export const escolaridadeKeyToLabel = (escolaridadeKey: IEscolaridade) => {
    switch (escolaridadeKey) {
        case 'ANALFABETO':
            return 'Analfabeto'
        case 'CURSO SEQUENCIAL COMPLEMENTACAO ESTUDOS':
            return 'Curso Sequencial Complementação Estudos'
        case 'CURSO SEQUENCIAL FORMACAO ESPECIFICA':
            return 'Curso Sequencial Formação Específica'
        case 'DOUTORADO':
            return 'Doutorado'
        case 'DOUTORADO COMPLETO':
            return 'Doutorado Completo'
        case 'FUNDAMENTAL':
            return 'Fundamental'
        case 'FUNDAMENTAL COMPLETO':
            return 'Fundamental Completo'
        case 'FUNDAMENTAL INCOMPLETO':
            return 'Fundamental Incompleto'
        case 'MEDIO':
            return 'Médio'
        case 'MEDIO COMPLETO':
            return 'Médio Completo'
        case 'MEDIO INCOMPLETO':
            return 'Médio Incompleto'
        case 'MESTRADO':
            return 'Mestrado'
        case 'MESTRADO COMPLETO':
            return 'Mestrado Completo'
        case 'POS DOUTORADO':
            return 'Pós-Doutorado'
        case 'POS DOUTORADO COMPLETO':
            return 'Pós-Doutorado Completo'
        case 'POS GRADUACAO COMPLETO':
            return 'Pós-Graduação Completo'
        case 'POS GRADUACAO LATO SENSU ESPECIALIZACAO':
            return 'Pós-Graduação Lato Sensu Especialização'
        case 'POS GRADUACAO LATO SENSU RESIDENCIA MEDICA':
            return 'Pós-Graduação Lato Sensu Residência Médica'
        case 'PRIMARIO COMPLETO':
            return 'Primário Completo'
        case 'PRIMARIO INCOMPLETO':
            return 'Primário Incompleto'
        case 'QUARTA SERIE ENSINO FUNDAMENTAL':
            return 'Quarta Série Ensino Fundamental'
        case 'SUPERIOR BACHARELADO':
            return 'Superior Bacharelado'
        case 'SUPERIOR COMPLETO':
            return 'Superior Completo'
        case 'SUPERIOR INCOMPLETO':
            return 'Superior Incompleto'
        case 'SUPERIOR LICENCIATURA CURTA':
            return 'Superior Licenciatura Curta'
        case 'SUPERIOR LICENCIATURA PLENA':
            return 'Superior Licenciatura Plena'
        case 'SUPERIOR TECNOLOGO':
            return 'Superior Tecnólogo'
        case 'TECNICO COMPLETO':
            return 'Técnico Completo'
        case 'TECNICO ESPECIALIZACAO':
            return 'Técnico Especialização'
        case 'TECNICO HABILITACAO':
            return 'Técnico Habilitação'
        case 'TECNICO INCOMPLETO':
            return 'Técnico Incompleto'
        case 'TECNICO QUALIFICACAO':
            return 'Técnico Qualificação'
        case 'TECNOLOGO COMPLETO':
            return 'Tecnólogo Completo'
        case 'TECNOLOGO INCOMPLETO':
            return 'Tecnólogo Incompleto'
        default:
            return 'Não definido'
    }
}
